<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
							<el-option label="订单编号" :value="1"></el-option>
							<el-option label="商品ID" :value="2"></el-option>
                            <el-option label="SKUID" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.type" placeholder="请选择" size="small">
                        <el-option label="仅看发货前 - 申请修改收货地址的" :value="1"></el-option>
                        <el-option label="仅看发货前 - 申请取消商品的" :value="2"></el-option>
                        <el-option label="仅看发货后 - 申请退货的" :value="3"></el-option>
						<el-option label="不限制售后类型" value=""></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                    <el-select v-model="params.status" placeholder="请选择" size="small" multiple  @change="changeStatus()">
                        <el-option label="仅看待审核的" :value="0"></el-option>
                        <el-option label="仅看已拒绝的" :value="1"></el-option>
                        <el-option label="仅看待退货的" :value="2"></el-option>
                        <el-option label="仅看待收货的" :value="3"></el-option>
                        <el-option label="仅看待退款的" :value="4"></el-option>
                        <el-option label="仅看已关闭的" :value="5"></el-option>						
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/goodsAfterSale/reason/list')" type="primary" icon="el-icon-set-up" size="small" @click="set()">配置售后原因</el-button>
            <el-button v-if="$utils.have('/goodsAfterSale/reminder/info')"  type="primary" icon="el-icon-edit" size="small" @click="prompt()">配置温馨提示</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
				<el-table-column prop="status" label="售后状态">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.status==0" type="success" size="mini">待审核</el-tag>
					    <el-tag v-if="scope.row.status==1" type="danger" size="mini">已拒绝</el-tag>
					    <el-tag v-else-if="scope.row.status==2" type="warning" size="mini">待退货</el-tag>
					    <el-tag v-else-if="scope.row.status==3" type="success" size="mini">待收货</el-tag>
					    <el-tag v-else-if="scope.row.status==4" type="danger" size="mini">待退款</el-tag>
					    <el-tag v-else-if="scope.row.status==5" type="info" size="mini">已关闭</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="售后类型"  min-width="180">
					<template slot-scope="scope">						
					    <span v-if="scope.row.type==1">发货前 - 申请修改收货地址</span>
					    <span v-else-if="scope.row.type==2">发货前 - 申请取消商品</span>
					    <span v-else-if="scope.row.type==3">发货后 - 申请退货</span>
					</template>
				</el-table-column>
                <el-table-column prop="orderSn" label="订单编号" min-width="120"></el-table-column>
                <el-table-column prop="goodsInfo" label="商品信息（ID 名称）" show-overflow-tooltip min-width="150"></el-table-column>				
                <el-table-column prop="skuInfo" label="SKU信息（ID 名称）" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column prop="userInfo" label="购买人（ID 名称 手机号）" min-width="120" show-overflow-tooltip ></el-table-column>				
                <el-table-column prop="address" label="收货地址（收货人 联系手机 省份 城市 地址）" min-width="250">                    
                </el-table-column>				
                <el-table-column prop="createTime" label="售后申请时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" min-width="150">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/goodsAfterSale/detail') && scope.row.status == 0 "
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="manage(scope.row.id)"
                            >审核</el-button>
                        <el-button
                            v-if="$utils.have('/goodsAfterSale/detail') && scope.row.status == 3 "
                            type="text"
                            size="small"
                            icon="el-icon-position"
                            @click="manage(scope.row.id)"
                            >确认收货</el-button>                       
                        <el-button
                            v-if="$utils.have('/goodsAfterSale/detail') && (scope.row.status == 1 || scope.row.status == 2|| scope.row.status == 4  || scope.row.status == 5 )"
                            type="text"
                            size="small"
                            icon="el-icon-money"
							 @click="manage(scope.row.id)"
                            >查看详情</el-button>
                    </template>    
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
		<Prompt ref="Prompt" :data="dataPrompt"  @onUpdate="getPrompt" ></Prompt>        
    </div>
</template>

<script>
import Prompt from './components/prompt';
const defaultParams = {
    pageNo:1,
    queryType: 1,
    queryValue: '',
	status:[0,2,3,4],
	//status:[0,1,2,3,4,5],
	type:''	
}
export default {
    components:{Prompt},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                queryType: parseInt(this.$route.query.queryType || 1),
                queryValue: this.$route.query.queryValue || '',
				type: this.$route.query.type ? parseInt(this.$route.query.type) : '',
            },
            dataPrompt:'',
            listLoading: true,            
            downLoading: false
        }
    },
    computed:{
        
    },
    mounted() {
		this.getPrompt()
        this.getDataList();
    },
    methods:{
		changeStatus(value){
			console.log(value)
		},
        //获取列表
        getDataList() {
			
            this.listLoading = true;
            this.params = {
                ...this.params			
            }
            this.$request({
                url: "/goodsAfterSale/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
           
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
       //配置售后原因
	   set(){
		    this.$router.push('/goodsManage/aftersales/set');
	   },
	   getPrompt(){
		   this.$request({
		       url: "/goodsAfterSale/reminder/info",
		       method: "POST",
		       data: {},
		   })
		       .then((res) => {
		           const { state, msg, result } = res.data;
		           if (state == 1 && result) {
		               this.dataPrompt = result || '';		               
		               
		           } else {
		               this.$message.error(msg || "请求失败");
		           }
		       })
		       .catch(() => {
		           this.$message.error("请求错误");
		       })
		       .finally(() => {
		           this.listLoading = false;
		       });
	   },
	   prompt(){		   
		   this.$refs.Prompt.show();
	   },
	   manage(id){	   		
			this.$router.push({
			    path:`/goodsManage/aftersales/edit/${id}`,
			    query: {
			        redirect: this.$utils.objArgs(
			            this.$router.currentRoute.path,
			            this.params
			        ),
			    },
			});
	   },
        
       
    }
}
</script>